import { useId } from "react";
import { Button } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";

interface OrdersBulkBarProps {
    selectedCount: number;
    // How many of the selected orders Mark Processed would move.
    markableCount: number;
    onMarkProcessed: () => void;
    onExport: () => void;
    onClear: () => void;
}

// The Orders list's bulk actions (#473), for the rows ticked on this page.
export const OrdersBulkBar = ({
    selectedCount,
    markableCount,
    onMarkProcessed,
    onExport,
    onClear,
}: OrdersBulkBarProps) => {
    const reasonId = useId();
    const canMark = markableCount > 0;

    return (
        <div
            role="region"
            aria-label="Bulk actions"
            className="mt-4 flex flex-wrap items-center gap-3 rounded-lg bg-base-200 px-4 py-2 text-neutral"
        >
            <span className="font-bold">{selectedCount} selected</span>
            <Button
                color={ComponentColor.Primary}
                size={ComponentSize.SM}
                disabled={!canMark}
                aria-describedby={canMark ? undefined : reasonId}
                onClick={onMarkProcessed}
            >
                Mark Processed
            </Button>
            <Button
                color={ComponentColor.Primary}
                size={ComponentSize.SM}
                outline
                onClick={onExport}
            >
                Export
            </Button>
            {/* Ghost over a light surface needs its own text colour (CLAUDE.md theme quirk). */}
            <Button
                color={ComponentColor.Ghost}
                size={ComponentSize.SM}
                className="text-neutral"
                onClick={onClear}
            >
                Clear selection
            </Button>
            {!canMark && (
                <span id={reasonId} className="text-sm text-neutral/70">
                    None of the selected orders can be marked Processed.
                </span>
            )}
        </div>
    );
};
